module.exports = __webpack_public_path__ + "static/media/ic_charley_filled.c8ee96c2.svg";